import { render } from "./auth-layout.vue?vue&type=template&id=eff33bae"
import script from "./auth-layout.vue?vue&type=script&lang=js"
export * from "./auth-layout.vue?vue&type=script&lang=js"

import "./auth-layout.vue?vue&type=style&index=0&id=eff33bae&lang=scss"
script.render = render

export default script